<template>
  <div class="">
    <div
      class="flex items-center border-b p-3 justify-between"
      v-for="(product, index) in products"
      :key="product.id"
    >
      <div class="flex items-center">
        <div class="w-24">
          <img :src="product.imageUrl" width="55px" alt="" />
        </div>
        <div class="flex flex-col">
          <div>{{ product.name }}</div>
          <copy-text>
            <router-link
              class="text-grey-darker text-xs no-underline hover:underline"
              :to="`/products/${product.productId}`"
              >{{ product.model }}</router-link
            >
          </copy-text>
        </div>
      </div>
      <div>
        <button @click="removeProductFromList(product.id, index)">
          <i class="fa fa-trash text-grey-dark"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import GET_SUPPLY_ORDER_PRODUCTS from '../../graphql/supplyOrderProducts.gql';
import { ref, onMounted, watch } from '@vue/composition-api';
import { groupBy, orderBy, keyBy, reduce, find, isEmpty } from 'lodash';
import useCartProducts from '../../composition/useCartProducts';
export default {
  props: ['order'],
  setup(props, ctx) {
    const products = ref([]);
    const { updateQuantity, removeProduct } = useCartProducts(ctx);

    onMounted(async () => {
      await getSupplyOrderProduct();
    });
    const getSupplyOrderProduct = async () => {
      let { data, loading } = await ctx.root.$apollo.query({
        fetchPolicy: 'network-only',
        query: GET_SUPPLY_ORDER_PRODUCTS,
        variables: {
          supplyOrderId: +props.order.id
        }
      });
      products.value = data.supplyOrderProducts;
    };

    async function removeProductFromList(id, index) {
      // const indexForRemoval = products.map(item => item.id).indexOf(id);
      removeProduct(id);
      products.value.splice(index, 1);
      ctx.root.$notify({ type: 'success', message: 'Removido com sucesso.' });
    }

    const onUpdateQuantity = (productId, quantity) => {
      updateQuantity(productId, quantity);
    };

    return {
      products,
      onUpdateQuantity,
      removeProductFromList
    };
  }
};
</script>



// WEBPACK FOOTER //
// CartProduct.vue?697dc71a